var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.isStickyHeader ? "sticky-header-on" : "sticky-header-off" },
    [
      _c(
        "Sticky",
        {
          model: {
            value: _vm.isStickyHeader,
            callback: function ($$v) {
              _vm.isStickyHeader = $$v
            },
            expression: "isStickyHeader",
          },
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStickyHeader,
                  expression: "isStickyHeader",
                },
              ],
              staticClass: "tabs hkld-tabs",
              attrs: { id: "sticky-tabs", "data-tabs": "" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "tabs-title sticky-tabs-nav",
                    attrs: { id: "tabs-nav" },
                  },
                  _vm._l(_vm.tabNames, function (tabName, index) {
                    return _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "checkVisibility",
                            rawName: "v-checkVisibility",
                          },
                        ],
                        key: index,
                        class: { "is-active-tab": index === 0 },
                        on: {
                          mousedown: function ($event) {
                            return _vm.tabMousedownAction(index)
                          },
                          click: function ($event) {
                            return _vm.navToTab("#tab-" + index, index, $event)
                          },
                        },
                      },
                      [
                        _vm._t("label-" + index, function () {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(tabName) +
                                "\n              "
                            ),
                            _vm._t("icon-" + index),
                          ]
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "float-right" },
                  [_vm._t("float-right")],
                  2
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "create-project-main" }, [
        _c(
          "ul",
          {
            staticClass: "row tabs hkld-tabs",
            style: _vm.extendStyleTabs,
            attrs: { id: "common-tabs", "data-tabs": "" },
          },
          _vm._l(_vm.tabNames, function (tabName, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "tabs-title column",
                class: { "is-active": index === 0 },
                style: {
                  overflow: _vm.showPopover(tabName) ? "visible" : "hidden",
                },
              },
              [
                _c(
                  "a",
                  {
                    directives: [
                      { name: "checkVisibility", rawName: "v-checkVisibility" },
                    ],
                    style: _vm.extendStyleA,
                    attrs: { href: "#tab-" + index },
                    on: {
                      mousedown: function ($event) {
                        return _vm.tabMousedownAction(index)
                      },
                      click: function ($event) {
                        return _vm.tabClickAction(index, $event)
                      },
                    },
                  },
                  [
                    _vm._t("label-" + index, function () {
                      return [
                        _vm._v(
                          "\n            " + _vm._s(tabName) + "\n            "
                        ),
                        _vm._t("icon-" + index),
                      ]
                    }),
                    _vm._v(" "),
                    _vm.showPopover(tabName)
                      ? _c("Popover", {
                          attrs: {
                            width: 300,
                            textAlign: "left",
                            text: _vm.$t("standaloneWorkPermits.text"),
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.isMoreTabs
          ? _c(
              "div",
              {
                staticClass: "hkld-tabs-content",
                attrs: { "data-tabs-content": "common-tabs" },
              },
              [_vm._t("tabs")],
              2
            )
          : _c(
              "div",
              {
                staticClass: "hkld-tabs-content",
                attrs: { "data-tabs-content": "common-tabs" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel is-active",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-0" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-0")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-1" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-1")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-2" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-2")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-3" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-3")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-4" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-4")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-5" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-5")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-6" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-6")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-7" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-7")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-8" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-8")], 2)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tabs-panel",
                    style: _vm.extendStyleContent,
                    attrs: { id: "tab-9" },
                  },
                  [_c("div", { staticClass: "clearfix" }, [_vm._t("tab-9")], 2)]
                ),
              ]
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }